var SPLIDE = (function() {
  function init() {
    if (document.querySelectorAll(".b-organizations__slider").length) {
      new Splide(".b-organizations__slider", {
        type: "loop",
        rewind: true,
        pagination: false,
        arrows: false,
        autoplay: true,
        perPage: 4,
        breakpoints: {
          991: {
            perPage: 3,
          },
          600: {
            perPage: 2,
          },
        },
      }).mount();
    }

    if (document.querySelectorAll(".b-testimonials__slider").length) {
      const slides = document.querySelectorAll(".splide__slide");
      const options = {
        type: "fade",
        rewind: true,
        pagination: false,
      };

      if (slides.length <= 1) {
        options["arrows"] = false;
      }
      new Splide(".b-testimonials__slider", options).mount();
    }
  }

  return {
    init: init,
  };
})();
